export default "__VITE_ASSET___Xwd3MBv__"